'use strict';

/* eslint-env node */

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./umd/history.production.min.js');
} else {
  module.exports = require('./umd/history.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/history/main.js
// module id = 4
// module chunks = 0